const SettingsConstants = {
  RESET: 'SR_SETTINGS_RESET',
  GET_SUCCESS: 'SR_SETTINGS_GET_SUCCESS',
  GET_FAIL: 'SR_SETTINGS_GET_FAIL',
  GET_FOR_OPEN: 'SR_SETTINGS_GET_FOR_OPEN',
  GET_FOR_OPEN_SUCCESS: 'SR_SETTINGS_GET_FOR_OPEN_SUCCESS',
  GET_FOR_OPEN_FAIL: 'SR_SETTINGS_GET_FOR_OPEN_FAIL',
  SAVE: 'SR_SETTINGS_SAVE',
  SAVE_SUCCESS: 'SR_SETTINGS_SAVE_SUCCESS',
  SAVE_FAIL: 'SR_SETTINGS_SAVE_FAIL',
  CREATE: 'SR_SETTINGS_CREATE',
  OPEN: 'SR_SETTINGS_OPEN',
  
  DONT_FETCH_USER_SETTINGS: 'SR_SETTINGS_DONT_FETCH_USER_SETTINGS',
  
  SET_UNITS_VALUE: 'SR_SETTINGS_SET_UNITS_VALUE',

  SET_VALUE: 'SR_SETTINGS_SET_VALUE',
  IS_SETTING_LANGUAGE: 'SR_SETTINGS_IS_SETTING_LANGUAGE',

  TOGGLE: 'SR_SETTINGS_TOGGLE',
  HIDE: 'SR_SETTINGS_HIDE'
};

export default SettingsConstants;